<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  <form #form="ngForm">
    @if (dataLoaded) {
      <div class="edit-employee-container">
        <div class="opm-grid">
          @if (!isAudit) {
            <div class="grid-caption">
              <div class="col-lg-6">
                Create Employee Profile
              </div>
              <div style="float:right">
                <input name="type" [(ngModel)]="type" type="radio" [value]="1" [checked]="options" /> Single User
                <input name="type" [(ngModel)]="type" type="radio" [value]="0" [checked]="!options" /> Bulk Upload
              </div>
              @if (profile.Errors.length > 0) {
                <a class="icon revert-error" href="#"
                  >
                  <ul>
                    @for (error of profile.Errors; track error) {
                      <li>
                        {{error}}
                      </li>
                    }
                  </ul>
                </a>
              }
              <br />
            </div>
          }
          @if (type == 0) {
            <div>
              <div class="grid-item">
                <span class="field">
                  <input type="file" (change)="selectFile($event)" />
                </span>
                <span class="value"></span>
                <span class="value">
                  <button class="btn btn-success" [ngStyle]="{'margin-top': '0px'}" (click)="upload()">
                    Upload
                  </button>
                  <a [routerLink]="" [ngStyle]="{'cursor': 'pointer', 'margin-left': '5%','color':'purple','text-decoration':'underline'}" (click)="DownloadTemplate()"> Download Template</a>
                </span>
              </div>
              @if (isshow) {
                <div class="opm-grid">
                  <div class="grid-caption">
                    Upload Status Logs
                  </div>
                  <div class="grid-header">
                    <span class="header-item" [ngStyle]="{'width': '80px'}">Excel Row <i class='fa fa-fw fa-sort'></i></span>
                    <span class="header-item" [ngStyle]="{'width': '600px'}">Profile Infrmation <i class='fa fa-fw fa-sort'></i></span>
                  </div>
                  @for (excelerror of bulkProfileResults; track excelerror; let isEven = $even) {
                    <div class="grid-item" [ngClass]="{odd: isEven}">
                      <span [ngStyle]="{'width': '80px'}">{{excelerror.RowId}}</span>
                      <span [ngStyle]="{'width': '600px'}">{{excelerror.Error}}</span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (type == 1) {
            <div>
              <div class="grid-item">
                <span class="field">Member Firm Code</span>
                <span class="value"></span>
                <span class="value">
                  <select class="form-control" [(ngModel)]="profile.Override.MemberFirmCode" name="memberFirmCode">
                    @for (code of dictionaries.MemberFirms; track code) {
                      <option>
                        {{code}}
                      </option>
                    }
                  </select>
                </span>
              </div>
              <div class="grid-item">
                <span class="field">Country Code - Description</span>
                <span class="value"></span>
                <span class="value">
                  <select class="form-control" [(ngModel)]="selectedCountry" (change)="changeCountry()" name="countryCode">
                    @for (country of dictionaries.Countries; track country) {
                      <option [ngValue]="country">
                        {{country.Code}} - {{country.Description}}
                      </option>
                    }
                  </select>
                </span>
              </div>
              <div class="grid-item">
                <span class="field" [ngClass]="{'has-error': form.controls.firstName?.invalid}">First Name</span>
                <span class="value"></span>
                <span class="value">
                  <input type="text"
                    class="form-control"
                    name="firstName" maxlength="75"
                    required #firstName ngModel>
                  </span>
                </div>
                <div class="grid-item">
                  <span class="field" [ngClass]="{'has-error': form.controls.lastName?.invalid}">Last Name</span>
                  <span class="value"></span>
                  <span class="value">
                    <input type="text" class="form-control"
                      name="lastName" maxlength="75"
                      required #lastName ngModel>
                    </span>
                  </div>
                  <div class="grid-item">
                    <span class="field" [ngClass]="{'has-error': form.controls.emailAddress?.invalid}">Email</span>
                    <span class="value"></span>
                    <span class="value">
                      <input type="text"
                        class="form-control"
                        name="emailAddress" [pattern]="emailPattern" maxlength="150"
                        required #emailAddress ngModel>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Office Code - Description</span>
                      <span class="value"></span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedOffice" (change)="changeOffice()" name="officeCode">
                          @for (office of dictionaries.Offices; track office) {
                            <option [ngValue]="office">
                              {{office.Code}} - {{office.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Employee Type</span>
                      <span class="value"></span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="profile.Override.EmployeeType" name="employeeType">
                          @for (code of dictionaries.EmployeeTypes; track code) {
                            <option [value]="code">
                              {{code}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Employee Status Code - Description</span>
                      <span class="value"></span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedStatus" (change)="changeStatus()" name="statusCode">
                          @for (status of dictionaries.Statuses; track status) {
                            <option [ngValue]="status">
                              {{status.Code}} - {{status.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Organization Code - Description</span>
                      <span class="value"></span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedOrganization" (change)="changeOrganization()" name="organizationCode">
                          @for (organization of dictionaries.Organizations; track organization) {
                            <option [ngValue]="organization">
                              {{organization.Code}} - {{organization.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">PPMD</span>
                      <span class="value"></span>
                      <span class="value">
                        <select class="form-control"
                          [ngModel]="profile.Override.PPMD"
                          (ngModelChange)="profile.Override.PPMD = parseBoolean($event)"
                          name="isPPMD">
                          @for (isPPMD of [true, false]; track isPPMD) {
                            <option [value]="isPPMD">
                              {{isPPMD | booleanFormatterPipe}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <button type="button" class="btn btn-primary pull-right" [disabled]="form.invalid" (click)="save()">Save</button>
                    <button type="button" class="btn btn-light pull-right" routerLink="">Cancel</button>
                  </div>
                }
              </div>
            </div>
          }
        </form>

        @if (visiblErrorPopup) {
          <opm-modal-popup
            header="Error"
            [cancelVisibility]="false"
            [message]="errorMessage"
            okButtonName="Ok"
            (onOk)="visiblErrorPopup = false">
          </opm-modal-popup>
        }
      </div>
      <opm-footer></opm-footer>
